/* tslint:disable */
/* eslint-disable */
/**
 * cellera-backend API spec
 * Backend Service for Cellera | [swagger.json](cellera/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateProtocolDeployment200ResponseData
 */
export interface UpdateProtocolDeployment200ResponseData {
    /**
     * 
     * @type {string}
     * @memberof UpdateProtocolDeployment200ResponseData
     */
    email?: string;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateProtocolDeployment200ResponseData
     */
    isAwaitingProtocolDeployment?: boolean;
}

/**
 * Check if a given object implements the UpdateProtocolDeployment200ResponseData interface.
 */
export function instanceOfUpdateProtocolDeployment200ResponseData(value: object): value is UpdateProtocolDeployment200ResponseData {
    return true;
}

export function UpdateProtocolDeployment200ResponseDataFromJSON(json: any): UpdateProtocolDeployment200ResponseData {
    return UpdateProtocolDeployment200ResponseDataFromJSONTyped(json, false);
}

export function UpdateProtocolDeployment200ResponseDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateProtocolDeployment200ResponseData {
    if (json == null) {
        return json;
    }
    return {
        
        'email': json['email'] == null ? undefined : json['email'],
        'isAwaitingProtocolDeployment': json['isAwaitingProtocolDeployment'] == null ? undefined : json['isAwaitingProtocolDeployment'],
    };
}

export function UpdateProtocolDeployment200ResponseDataToJSON(json: any): UpdateProtocolDeployment200ResponseData {
    return UpdateProtocolDeployment200ResponseDataToJSONTyped(json, false);
}

export function UpdateProtocolDeployment200ResponseDataToJSONTyped(value?: UpdateProtocolDeployment200ResponseData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'email': value['email'],
        'isAwaitingProtocolDeployment': value['isAwaitingProtocolDeployment'],
    };
}

